import React from "react";

import styles from '../ClaimWizard.scss'


const WizardModalContent= ({modalTitle, children}) => {
   
        return (
            <div className={styles.modalContent} key={'wizardModalContent'}>
                <span className={styles.title} >{modalTitle}</span>
                {children}
            </div>
        )
}

export default WizardModalContent


// WEBPACK FOOTER //
// ./components/ClaimsWizard/shared/WizardModalContent.jsx